import { some } from "lodash";
import { Platform } from "@linkfluence/models/platform";
import {
  getImageFallbackUrl,
  getImageFallbackUrlFromClusterPost,
} from "@radarly/api/post";
import { ClusterPost, Post, PostLens } from "./posts";
import { Project, getProjectCredentials } from "./project";

type Usage = {
  picture: { id: number; url: string };
  corpora: number[];
  dashboards: number[];
  focuses: number[];
  geoLocations: number[];
  geoTags: number[];
  benchmarkEntities: number[];
  isProjectPicture: boolean;
};

export type PicturesUsage = {
  usage: Usage[];
};

export type PictureUsedSources = {
  [key in Exclude<keyof Usage, "picture" | "isProjectPicture">]: number[];
}[];

export type UsedPicturePayload = {
  pictureId: number;
  sourceType: keyof Usage;
  sourceId: number;
};

const fallbackPlatforms: Platform[] = [Platform.Instagram, Platform.Facebook];

export function getCoverFallback(post: PostLens<Post>, project: Project) {
  if (!project) {
    return null;
  }

  const postPlatform = post.getPlatform();

  if (fallbackPlatforms.includes(postPlatform)) {
    const platformCredentials = getProjectCredentials(project, postPlatform);
    const hasAvailableCredentials = some(platformCredentials, {
      error: false,
    });
    return hasAvailableCredentials
      ? getImageFallbackUrl(postPlatform, project.id, post)
      : null;
  } else {
    return null;
  }
}

export function getCoverFallbackFromClusterPost(
  post: ClusterPost,
  project: Project
) {
  if (!project) {
    return null;
  }
  if (fallbackPlatforms.includes(post.platform)) {
    const platformCredentials = getProjectCredentials(project, post.platform);
    const hasAvailableCredentials = some(platformCredentials, {
      error: false,
    });
    return hasAvailableCredentials
      ? getImageFallbackUrlFromClusterPost(post.platform, project.id, post)
      : null;
  } else {
    return null;
  }
}
